// Tauri 런타임 감지 — webview 안에서 @tauri-apps/api 가 노출됐을 때만 활성.
// 일반 브라우저에서는 false → 기존 Web Notification API 폴백 경로 유지.

declare global {
	interface Window {
		__TAURI_INTERNALS__?: unknown;
		__TAURI__?: unknown;
	}
}

export function isTauri(): boolean {
	if (typeof window === 'undefined') return false;
	return !!(window.__TAURI_INTERNALS__ || window.__TAURI__);
}

/** 🪟 이 창이 팝아웃(별도 창)인가 — 메인 창이 아니면 true. App.tsx 메인 창 리스너·popout·openExternal 공용 판정 (2026-09-29).
 *  의존성 없는 여기에 둔다 — openExternal ↔ popout 이 서로를 import 하는 순환을 피하려고. */
export function isPopoutWindow(): boolean {
	try {
		return new URLSearchParams(window.location.search).get('win') === '1'
			|| /^\/(ai|calendar|room|admin|help|connect|links|share|preview|voc|sms|forms|signup-manage|org-manage|pjt-settings|pjt-compare|widget)(\/|$)/.test(window.location.pathname);
	} catch { return false; }
}
